<template>
  <el-form
    ref="form"
    :inline="true"
    :model="form"
    :rules="rules"
    class="demo-form-inline"
  >
    <el-row :gutter="30" class="app-address-item" style="padding:0 16px">
      <el-row
        style="text-align: left;flex-wrap: wrap"
        type="flex"
        justify="space-between"
      >
        <!--        <el-form-item :label="value.addressName" style="margin-bottom:15px;text-align: left"></el-form-item>-->
        <div>
          <span class="fz18 fw400">{{ value.addressName }}</span>
          <span
            type="text"
            v-if="+value.isDefault === 1"
            class="fz12 app-address-item--default"
          >
            默认地址
          </span>
          <el-button
            class="inline-block"
            v-if="+value.isDefault !== 1 && formEnable"
            type="text"
            size="small"
            @click.native="$emit('setDefault')"
          >
            设置为默认地址
          </el-button>
        </div>
        <!--        <div style="display:inline-flex;margin-top: 5px;width:200px;align-items: center">-->
        <el-button
          size="small"
          :style="{ display: formEnable ? 'block' : 'none' }"
          type="text"
          @click.native="remove"
        >
          删除
        </el-button>
        <!--        </div>-->
      </el-row>
      <el-col :xs="12" :sm="12" :lg="8" :xl="8">
        <el-form-item
          style="width:100%;display:inline-flex"
          v-if="formEnable"
          label="收件地址名称"
          prop="addressName"
        >
          <el-input size="mini" v-model="form.addressName"></el-input>
        </el-form-item>
      </el-col>
      <el-col :xs="12" :sm="12" :lg="8" :xl="8">
        <el-form-item
          style="width:100%;display:inline-flex"
          label="收件人"
          prop="receiptFullName"
        >
          <el-input
            size="mini"
            :disabled="!formEnable"
            v-model="form.receiptFullName"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :xs="12" :sm="12" :lg="8" :xl="8">
        <el-form-item
          style="width:100%;display:inline-flex"
          label="联系电话"
          prop="receiptPhone"
        >
          <el-input
            size="mini"
            :disabled="!formEnable"
            v-model="form.receiptPhone"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :xs="12" :sm="12" :lg="8" :xl="8">
        <el-form-item
          style="width:100%;display:inline-flex"
          label="发票邮寄地址"
          prop="receiptAddress"
        >
          <el-input
            size="mini"
            :disabled="!formEnable"
            v-model="form.receiptAddress"
          ></el-input>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
export default {
  name: 'AddressListItem',
  props: ['value', 'formEnable'],
  data() {
    const validate0 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('收件地址名不能为空'));
      } else if (value.length > 100) {
        callback(new Error('收件地址名长度为 100 字符以内'));
      } else {
        callback();
      }
    };
    const validate = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('收件人不能为空'));
      } else if (value.length > 100) {
        callback(new Error('收件人长度为 100 字符以内'));
      } else {
        callback();
      }
    };

    const validate1RE = /^\d{11}$/;
    const validate1 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('联系电话不能为空'));
      } else if (!validate1RE.test(value)) {
        callback(new Error('联系电话必须是11位数字）'));
      } else {
        callback();
      }
    };

    const validate2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('发票邮寄地址不能为空'));
      } else if (value.length > 200) {
        callback(new Error('发票地址长度为 200 个字符以内'));
      } else {
        callback();
      }
    };
    return {
      rules: {
        addressName: [
          {
            validator: validate0,
            trigger: 'blur'
          }
        ],
        receiptFullName: [
          {
            validator: validate,
            trigger: 'blur'
          }
        ],
        receiptPhone: [
          {
            validator: validate1,
            trigger: 'blur'
          }
        ],
        receiptAddress: [
          {
            validator: validate2,
            trigger: 'blur'
          }
        ]
      }
    };
  },
  computed: {
    form: {
      get: function() {
        return this.value;
      },
      set: function(v) {
        this.$emit('input', v);
      }
    }
  },
  methods: {
    validate() {
      return this.$refs['form'].validate();
    },
    remove() {
      // 优化代码
      this.$confirm('是否删除该地址', {})
        .then(() => {
          this.$emit('remove');
        })
        .catch(() => {});
    }
  }
  // watch: {
  //   form: {
  //     handler: function(v) {
  //       if (!v) return;
  //       this.$emit('input',this.form);
  //     }
  //   }
  // }
};
</script>

<style scoped lang="scss">
.app-address-item {
  background-color: #fff;
  position: relative;
  width: 95%;
  left: 50%;
  transform: translateX(-50%);
  margin-top: 16px;
  border: 1px dashed #cbcbcb;
  //border-color: #cbcbcb #cbcbcb #cbcbcb #cbcbcb;

  &::before {
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 2px;
    //background: repeating-linear-gradient(-45deg, #ff6c6c, #ff6c6c 20%, transparent 0, transparent 25%, #1989fa 0, #1989fa 45%, transparent 0, transparent 50%);
    background-size: 80px;
    content: '';
  }

  &--default {
    display: inline-block;
    height: 20px;
    line-height: 20px;
    background: #ff6c6c;
    color: #fff;
    padding: 0 5px;
    border-radius: 0 20px 20px 0;
    margin: 0 5px;
    user-select: none;
  }
}
</style>
